<template>
  <div class="video-wrp">
    <div class="breadcrumb">
      <span class="label">{{ title }}</span>
      <span class="links">
        <router-link to="/">主站</router-link>/<router-link
          v-if="routeInfo"
          :to="routeInfo.url"
          >{{ routeInfo.name }} </router-link
        ><span v-if="routeInfo">/</span><a>{{ title }}</a>
      </span>
    </div>
    <div v-if="false" class="pay">
      <div class="wrp">
        <div class="tip">付费会员可观看！</div>
        <div class="pay-btn">付费会员可观看！</div>
      </div>
    </div>
    <div v-else>
      <video-player
        v-if="playerOptions"
        class="vjs-custom-skin vjs-big-play-centered"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        @ready="handlePlayerReady"
        @timeupdate="handleTimeUpdate"
      >
      </video-player>
      <div class="ep-title" v-if="episodes && episodes.length > 0">选集</div>
      <div class="list-wrp">
        <div
          v-for="(item, index) in episodes"
          :key="index"
          @click="select(index)"
        >
          <div class="episode" :class="{ active: curIdx === index }">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      episodes: [],
      cover: "",
      curIdx: 0,
      playerOptions: null,
      title: "",
      record: ""
    };
  },
  computed: {
    routeInfo() {
      let from = this.$route.query.from;
      switch (from) {
        case "fun":
          return {
            name: "趣味科普",
            url: "/fun"
          };
        case "sh":
          return {
            name: "生活圈",
            url: "/sh"
          };
        case "gc":
          return {
            name: "国产动画",
            url: "/gc"
          };
        case "jp":
          return {
            name: "日本动画",
            url: "jp"
          };
        case "dy":
          return {
            name: "电影",
            url: "/dy"
          };
        case "tv":
          return {
            name: "电视剧",
            url: "/tv"
          };
        case "live":
          return {
            name: "直播",
            url: "/live"
          };
        default:
          return null;
      }
    }
  },
  methods: {
    setOptFromJson() {
      let obj = window.clientJSON[this.$route.query.id];
      this.playerOptions = {
        height: "550",
        width: "980",
        autoplay: false,
        muted: true,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            // mp4
            src: `//www.720play.com/videos/${obj.url}`
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }
        ],
        poster: `//www.720play.com/pics/${obj.pic}`
      };
      this.title = obj.title;
    },
    setOptFromEp(ep) {
      this.playerOptions = {
        height: "360",
        width: "900",
        autoplay: false,
        muted: true,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            // mp4
            src: ep.url
            // webm
            // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
          }
        ],
        poster: `//www.720play.com/pics/${this.cover}`
      };
    },
    select(index) {
      this.curIdx = index;
      this.setOptFromEp(this.episodes[index]);
    },
    handlePlayerReady() {
      this.playerReadied();
      this.setRecord();
    },
    playerReadied() {
      if (
        this.$refs.videoPlayer &&
        this.$refs.videoPlayer.$el &&
        this.$refs.videoPlayer.$el.firstElementChild
      ) {
        const divele = document.createElement("div");
        const imgele = document.createElement("img");
        imgele.setAttribute("src", require("../assets/watermark720.png"));
        divele.classList.add("watermark");
        divele.appendChild(imgele);
        this.$refs.videoPlayer.$el.firstElementChild.appendChild(divele);
      }
    },
    setRecord() {
      if (
        this.$refs.videoPlayer &&
        this.$refs.videoPlayer.$el &&
        this.$refs.videoPlayer.$el.firstElementChild &&
        this.record
      ) {
        const divele = document.createElement("div");
        divele.id = "player-record";
        divele.classList.add("record-wrap");
        divele.innerHTML = this.record;
        this.$refs.videoPlayer.$el.firstElementChild.appendChild(divele);
      }
    },
    handleTimeUpdate() {
      if (!this.$refs.videoPlayer) {
        return;
      }
      if (!this.$refs.videoPlayer.player) {
        return;
      }
      if (!this.$refs.videoPlayer.$el) {
        return;
      }
      if (!this.$refs.videoPlayer.$el.firstElementChild) {
        return;
      }

      const recordEl = document.getElementById("player-record");
      if (!recordEl) {
        return;
      }

      const currentTime = parseInt(this.$refs.videoPlayer.player.currentTime());
      if (currentTime > 20) {
        recordEl.innerHTML = "";
      } else if (currentTime <= 20 && !recordEl.innerHTML) {
        recordEl.innerHTML = this.record;
      }
    }
  },
  beforeMount() {
    let dynamic = this.$route.query.dynamic;
    let id = this.$route.query.id;

    if (!id) {
      window.location.href = "/404";
      return;
    }
    if (dynamic) {
      axios.get(`/pgc/vest/view?season_id=${id}`).then(res => {
        if (res && res.status === 200 && res.data.code === 0) {
          let result = res.data.result;
          let episodes = result.episodes;

          episodes = episodes.sort((a, b) => {
            return parseInt(a.title) - parseInt(b.title);
          });
          this.episodes = episodes;
          this.curIdx = 0;
          this.title = result.title;
          this.record = result.licence_no;
          this.setOptFromEp(this.episodes[0]);
        }
      });
    } else {
      if (window.clientJSON) {
        this.setOptFromJson();
      } else {
        this.$root.$on("json_ready", this.setOptFromJson);
      }
    }
  },
  updated() {}
};
</script>

<style lang="less">
.video-wrp {
  width: 980px;
  margin: 0 auto;
  margin-bottom: 40px;
}

.ep-title {
  font-size: 20px;
  color: #000000;
  margin-bottom: 10px;
}

.episode {
  width: 155px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #3388ff;
  border: 1px solid #3388ff;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  cursor: pointer;

  &.active {
    background: #3388ff;
    color: #fff;
  }
}

.list-wrp {
  overflow: hidden;

  .episode {
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.pay {
  background: rgba(33, 33, 33, 0.9);
  border-radius: 8px;
  position: relative;
  height: 400px;
  margin-bottom: 10px;

  .tip {
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    line-height: 20px;
  }

  .pay-btn {
    width: 120px;
    height: 40px;
    background: #fa951e;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    margin: 10px auto;
    cursor: pointer;
  }

  .wrp {
    position: absolute;
    top: 40%;
    left: 0;
    right: 0;
  }
}

.breadcrumb {
  margin-bottom: 20px;

  .label {
    font-size: 20px;
    color: #000000;
  }

  .links {
    margin-left: 10px;
    color: #3388ff;
    font-size: 12px;

    a {
      color: #000000;
    }
  }
}

.watermark {
  position: absolute;
  top: 0;
  right: 0;
  margin: 20px;

  img {
    opacity: 0.5;
  }
}

.record-wrap {
  position: absolute;
  bottom: 40px;
  left: 0px;
  right: 0px;
  height: 20px;
  color: #fff;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  pointer-events: none;
  user-select: none;
  white-space: nowrap;
}
</style>
